import Vue from 'vue'
import VueRouter from 'vue-router'

import usersRoutes     from './routes/users.routes';
import terapiasRoutes  from './routes/terapias.routes';
import procesosRoutes  from './routes/procesos.routes';
import administracionRoutes  from './routes/administracion.routes';
import admisionRoutes  from './routes/admision.routes';

import { faLaptopHouse } from '@fortawesome/free-solid-svg-icons'
import odontologiaRoutes from './routes/odontologia.routes';

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    ...usersRoutes,
    ...administracionRoutes,
    ...admisionRoutes,
    ...terapiasRoutes,
    ...procesosRoutes,
    ...odontologiaRoutes,

    {
      path: '/consultar_citas',
      name: 'consultar_citas',
      component: () => import('@/views/citas/pages/ConsultarCita.vue'),
      meta: {
        hideBreadcrumb: true,
        pageTitle: 'Cita',
        breadcrumb: [
          {
            text: 'Consultar Citas',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'citamedica_consultar_cita', // si existe
        // accion1: { url: '/crear_cita' },
        excel: false,
        pdf: false,
      },
    },

    {
      path: '/derivaciones',
      name: 'derivaciones',
      component: () => import('@/views/derivaciones/pages/DerivacionesPage.vue'),
      meta: {
        hideBreadcrumb: true,
        pageTitle: 'Derivaciones',
        breadcrumb: [
          {
            text: 'Consultar Derivaciones',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'derivaciones_consultar', // si existe
        excel: true,
        pdf: true,
      },
    },

    {
      path: '/interconsultas',
      name: 'interconsultas',
      component: () => import('@/views/derivaciones/pages/InterconsultasPage.vue'),
      meta: {
        hideBreadcrumb: true,
        pageTitle: 'Interconsultas',
        breadcrumb: [
          {
            text: 'Interconsultas',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'interconsultas_consultar', // si existe
      },
    },

    {
      path: '/consultar_signos_vital',
      name: 'consultar_signos_vital',
      component: () => import('@/views/signosVitales/ConsultarSignosVitales.vue'),
      meta: {
        pageTitle: 'Signos Vitales',
        breadcrumb: [
          {
            text: 'Consultar Signos Vitales',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'citamedica_crear_signosvital',
      },
    },


    {
      path: '/atenciones-medicas',
      name: 'atenciones-medicas',
      component: () => import('@/views/atencionMedica/pages/AtencionesMedicas.vue'),
      meta: {
        pageTitle: 'Atenciones Medicas',
        breadcrumb: [
          {
            text: 'Atenciones Medicas',
          },
          {
            text: 'Atenciones Medicas ',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'atencionmedica_consultaratencionmedica', // Permiso requerido agregado
      },
    },
    {
      path: '/consultar-imagenes',
      name: 'consultar-imagenes',
      component: () => import('@/views/imagen/pages/ConsultarImagenProgramada.vue'),
      meta: {
        pageTitle: 'Imagenes',
        breadcrumb: [
          {
            text: 'Programar Imagenes',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_imagen_programada', // Permiso requerido agregado
      },
    },

    {
      path: '/consultar_cartera_imagen',
      name: 'consultar_cartera_imagen',
      component: () => import('@/views/imagen/pages/CarteraImagen.vue'),
      meta: {
        pageTitle: 'Consultar Cartera de Servicio Imagen',
        breadcrumb: [
          {
            text: 'Servicios Imagen',
          },
          {
            text: 'Imagenes',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_cartera_examen', // Permiso requeridon agregado
      },
    },
    {
      path: '/dicom-viewer/:token',
      name: 'dicom_viewer',
      component: () => import('@/views/imagen/pages/Dicomviewer.vue'),
      meta: { requiresAuth: true }
    },
    
    {
      path: '/ver_imagen/:token',
      name: 'ver_imagen',
      component: () => import('@/views/imagen/Verimagen.vue'),
      meta: {
        
        pageTitle: 'Ver Imagen',
        breadcrumb: [
          {
            text: 'Servicios Imagen',
            to: '/consultar_cartera_imagen'
          },
          {
            text: 'Ver Imagen',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'ver_imagen', // Permiso requerido agregado
      },
    },
    {
      path: '/crear_paquete',
      name: 'crear_paquete',
      component: () => import('@/views/enfermedadesPreventivas/pages/CrearPaquete.vue'),
    },
    {
      path: '/consultar_paquetes_preventivos',
      name: 'consultar_paquetes_preventivos',
      component: () => import('@/views/enfermedadesPreventivas/pages/ConsultarPaquetes.vue'),
      meta: {
        pageTitle: 'Paquetes Preventivos',
        breadcrumb: [
          { text: 'Prevención', },
          { text: 'Paquetes Preventivos', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'enfprev_consultar_paquetes',
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/consulta_paquete_asignado',
      name: 'consulta_paquete_asignado',
      component: () => import('@/views/enfermedadesPreventivas/pages/ConsultarPaqueteAsignado.vue'),
      meta: {
        pageTitle: 'Consulta de Paquetes Asignados',
        breadcrumb: [
          { text: 'Prevención' },
          { text: 'Paquetes Asignados', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'enfprev_asignar_paquete',
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/ver_paquete_preventivo/:id',
      name: 'ver_paquete_preventivo',
      component: () => import('@/views/enfermedadesPreventivas/pages/VerPaquete.vue'),
      meta: {
        pageTitle: 'Ver Paquete Preventivo',
        breadcrumb: [
          { text: 'Prevención', to: '/consultar_paquetes_preventivos' },
          { text: 'Ver Paquete', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'enfprev_consultar_paquetes',
      },
    },
    {
      path: '/editar_paquete_preventivo/:id',
      name: 'editar_paquete_preventivo',
      component: () => import('@/views/enfermedadesPreventivas/pages/CrearPaquete.vue'),
      meta: {
        pageTitle: 'Editar Paquete Preventivo',
        breadcrumb: [
          { text: 'Prevención', to: '/consultar_paquetes_preventivos' },
          { text: 'Editar Paquete', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'enfprev_consultar_paquetes',
      },
    },
    {
      path: '/consultar_cartera_farmaco',
      name: 'consultar_cartera_farmaco',
      component: () => import('@/views/farmacia/Consultarfarmaco.vue'),
      meta: {
        pageTitle: 'Consultar Farmacos',
        breadcrumb: [
          {
            text: 'Consultar Farmacos',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_cartera_examen', // Permiso requerido agregado
      },
    },
    {
      path: '/consultar_cartera_insumo',
      name: 'consultar_cartera_insumo',
      component: () => import('@/views/farmacia/CarteraInsumos.vue'),
      meta: {
        pageTitle: 'Consultar Insumos',
        breadcrumb: [
          {
            text: 'Consultar Insumos',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_cartera_examen',
      },
    },
    {
      path: '/ver_farmaco/:token',
      name: 'ver_farmaco',
      component: () => import('@/views/farmacia/Verfarmaco.vue'),
      meta: {
        pageTitle: 'Ver Farmaco',
        breadcrumb: [
          {
            text: 'Consultar Farmacos',
            to: '/consultar_cartera_farmaco'
          },
          {
            text: 'Ver Farmaco',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'ver_farmaco', // Permiso requerido
      },
    },
    {
      path: '/editar_farmaco/:token',
      name: 'editar_farmaco',
      component: () => import('@/views/farmacia/Editarfarmaco.vue'),
      meta: {
        pageTitle: 'Editar Farmaco',
        breadcrumb: [
          {
            text: 'Consultar Farmacos',
            to: '/consultar_cartera_farmaco'
          },
          {
            text: 'Editar Farmaco',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'editar_farmaco', // Permiso requerido listo
      },
    },
    {
      path: '/crear_farmaco',
      name: 'crear_farmaco',
      component: () => import('@/views/farmacia/Crearfarmaco.vue'),
      meta: {
        pageTitle: 'Crear Farmaco',
        breadcrumb: [
          {
            text: 'Consultar Farmacos',
            to: '/consultar_cartera_farmaco'
          },
          {
            text: 'Crear Farmaco',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'crear_farmaco', // Permiso requerido agregado 
      },
    },
    {
      path: '/consultar_receta_creada',
      name: 'consultar_receta_creada',
      component: () => import('@/views/farmacia/Consultarreceta.vue'),
      meta: {
        pageTitle: 'Consultar Recetas',
        breadcrumb: [
          {
            text: 'Recetas',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_recetas', // Permiso requerido agregado
      },
    },
    {
      path: '/retirar_receta/:id',
      name: 'retirar_receta',
      component: () => import('@/views/farmacia/Retirarreceta.vue'),
      meta: {
        pageTitle: 'Retirar receta',
        breadcrumb: [
          {
            text: 'Recetas',
            to: '/consultar_receta_creada'
          },
          {
            text: 'Retirar Recetas',
            active: true,
          },
          
        ],
        requiresAuth: true,
        requiredPermission: 'retirar_recetas', // Permiso requerido
      },
    },

    {
      path: '/consultar_examen_lab',
      name: 'consultar_examen_lab',
      component: () => import('@/views/laboratorio/pages/ConsultarExamenes.vue'),
      meta: {
        pageTitle: 'Estudios de laboratorio',
        breadcrumb: [
          {
            text: 'Laboratorio',
          },
          {
            text: 'Examenes de laboratorio',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_examen_lab', // Permiso requerido
      },
    },
    {
      path: '/consultar_cartera_examen',
      name: 'consultar_cartera_examen',
      component: () => import('@/views/laboratorio/Carteralaboratorio.vue'),
      meta: {
        pageTitle: 'Consultar Examenes de Laboratorio',
        breadcrumb: [
          {
            text: ' Cartera Laboratorio',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_cartera_examen', // Permiso requerido
        // accion1: { url: '/crear_laboratorio' },
      },
    },
    {
      path: '/crear_laboratorio',
      name: 'crear_laboratorio',
      component: () => import('@/views/laboratorio/CrearLaboratorio.vue'),
      meta: {
        pageTitle: 'Crear Laboratorio',
        breadcrumb: [
          {
            text: 'Examenes Laboratorio',
            to: '/consultar_cartera_examen',
          },
          {
            text: 'Crear Laboratorio',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'crear_laboratorio', // Permiso requerido agregado
      },
    },
    {
      path: '/ver_laboratorio/:token',
      name: 'ver_laboratorio',
      component: () => import('@/views/laboratorio/Verlaboratorio.vue'),
      meta: {
        pageTitle: 'Ver Proceso Clinico',
        breadcrumb: [
          {
            text: 'Laboratorio Clinico',
            to: '/consultar_cartera_examen',
          },
          {
            text: 'Ver Laboratorio Clinico',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'ver_laboratorio', // Permiso requerido
      },
    },

    
    {
      path: '/consultar_cirugia_programada',
      name: 'consultar_cirugia_programada',
      component: () => import('@/views/cirugia/Consultarcirugiaprogramada.vue'),
      meta: {
        pageTitle: 'Consultar Cirugias Programadas',
        breadcrumb: [
          {
            text: 'Cirugias Programadas',
          },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_cirugia_programada', // Permiso requerido
      },
    },
    {
      path: '/consultar_cartera_cirugia',
      name: 'consultar_cartera_cirugia',
      component: () => import('@/views/cirugia/Carteracirugia.vue'),
      meta: {
        pageTitle: 'Cartera Cirugias',
        // breadcrumb: [
        //   {
        //     text: 'Cartera Cirugias',
        //   },
        // ],
        requiresAuth: true,
        accion1: { url: '/crear_cirugia' },
      },
    },
    {
      path: '/crear_cirugia',
      name: 'crear_cirugia',
      component: () => import('@/views/cirugia/Crearcirugia.vue'),
      meta: {
        pageTitle: 'Crear Cirugia',
        breadcrumb: [
          {
            text: 'Procesos Clinicos',
            to: '/consultar_cartera_cirugia',
          },
          
        ],
        requiresAuth: true,
        requiredPermission: 'crear_cirugia', // Permiso requerido
      },
    },
    {
      path: '/editar_cirugia/:token',
      name: 'editar_cirugia',
      component: () => import('@/views/cirugia/Editarcirugia.vue'),
      meta: {
        pageTitle: 'Editar Cirugia',
        breadcrumb: [
          {
            text: 'Cartera Cirugias',
            to: '/consultar_cartera_cirugia',
          },
          {
            text: 'Editar Cirugia',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'editar_cirugia', // Permiso requerido
      },
    },
    {
      path: '/ver_cirugia/:id',
      name: 'ver_cirugia',
      component: () => import('@/views/cirugia/Vercirugia.vue'),
      meta: {
        pageTitle: 'Ver Cirugia',
        breadcrumb: [
          {
            text: 'Cirugia',
            to: '/consultar_cartera_cirugia',
          },
          {
            text: 'Ver Cirugia',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'ver_cirugia', // Permiso requerido
      },
    },

    {
      path: '/consultar_procesoclinico',
      name: 'consultar_procesoclinico',
      component: () => import('@/views/procesoclinico/pages/ConsultarProcesosClinicos.vue'),
      meta: {
        pageTitle: 'Procesos Clinicos',
        // breadcrumb: [
        //   {
        //     text: 'Procesos Clínicos',
        //   },
         
        // ],
        requiresAuth: true,
        requiredPermission: 'consultar_procesoclinico', 
        excel: false,
        pdf: false,
      },
    },
    
    
    {
      path: '/editar_procedimiento/:token',
      name: 'editar_procedimiento',
      component: () => import('@/views/procesoclinico/EditarprocedimientoV2.vue'),
      meta: {
        pageTitle: 'Editar Proceso Clinico',
        breadcrumb: [
          {
            text: 'Procesos Clinicos',
            to: '/consultar_cartera_procesoclinico',
          },
          {
            text: 'Editar Proceso Clinico',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'editar_procedimiento', // Permiso requerido
      },
    },
    {
      path: '/ver_procedimiento/:id',
      name: 'ver_procedimiento',
      component: () => import('@/views/procesoclinico/Verprocedimiento.vue'),
      meta: {
        pageTitle: 'Ver Proceso Clinico',
        breadcrumb: [
          {
            text: 'Procesos Clinicos',
            to: '/consultar_cartera_procesoclinico',
          },
          {
            text: 'Ver Proceso Clinico',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'ver_procedimiento', // Permiso requerido agregado
      },
    },

    
    {
      path: '/editar_item_odontologia/:token',
      name: 'editar_item_odontologia',
      component: () => import('@/views/odontologia/EditarItemOdontologia.vue'),
      meta: {
        pageTitle: 'Editar Item',
        breadcrumb: [
          {
            text: 'Procedimientos Odontologicos',
            to: '/consultar_cartera_odontologia',
          },
          {
            text: 'Editar Item',
            active: true,
          },
        ],
        requiresAuth: true,
        //requiredPermission: 'editar_procedimiento', // Permiso requerido
      },
    },
    {
      path: '/ver_item_odontologia/:id',
      name: 'ver_item_odontologia',
      component: () => import('@/views/odontologia/VerItemOdontologia.vue'),
      meta: {
        pageTitle: 'Ver Item Odontologia',
        breadcrumb: [
          {
            text: 'Procesos Clinicos',
            to: '/consultar_cartera_odontologia',
          },
          {
            text: 'Ver Item Odontologia',
            active: true,
          },
        ],
        requiresAuth: true,
        //requiredPermission: 'ver_procedimiento', // Permiso requerido agregado
      },
    },

    {
      path: '/produccion/tablas-graficos',
      name: 'produccion_tablas_graficos',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Tablas y gráficos' },
      meta: {
        pageTitle: 'Tablas y gráficos',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Tablas y gráficos', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/paquetes-servicios',
      name: 'produccion_paquetes_servicios',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Paquetes servicios' },
      meta: {
        pageTitle: 'Paquetes servicios',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Paquetes servicios', active: true },
        ],
        requiresAuth: true,
        requiredPermission: '',
      },
    },
    {
      path: '/produccion/servicios-mas-solicitados',
      name: 'produccion_servicios_mas_solicitados',
      component: () => import('@/views/produccion/ServiciosMasSolicitados.vue'),
      meta: {
        pageTitle: 'Servicios más solicitados',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Servicios más solicitados', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/marketing-enfermedades',
      name: 'produccion_marketing_enfermedades',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Marketing enfermedades' },
      meta: {
        pageTitle: 'Marketing enfermedades',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Marketing enfermedades', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/marketing-geolocalizado',
      name: 'produccion_marketing_geolocalizado',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Marketing geolocalizado' },
      meta: {
        pageTitle: 'Marketing geolocalizado',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Marketing geolocalizado', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/regresion-lineal',
      name: 'produccion_regresion_lineal',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Regresión lineal' },
      meta: {
        pageTitle: 'Regresión lineal',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Regresión lineal', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/analisis-costos',
      name: 'produccion_analisis_costos',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Análisis costos' },
      meta: {
        pageTitle: 'Análisis costos',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Análisis costos', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/prediccion-demanda',
      name: 'produccion_prediccion_demanda',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Predicción demanda' },
      meta: {
        pageTitle: 'Predicción demanda',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Predicción demanda', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/optimizacion-recursos',
      name: 'produccion_optimizacion_recursos',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Optimización recursos' },
      meta: {
        pageTitle: 'Optimización recursos',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Optimización recursos', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/kpi-produccion',
      name: 'produccion_kpi',
      component: () => import('@/views/produccion/KpiProduccion.vue'),
      meta: {
        pageTitle: 'KPI producción',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'KPI producción', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/rentabilidad-departamentos',
      name: 'produccion_rentabilidad_departamentos',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Rentabilidad departamentos' },
      meta: {
        pageTitle: 'Rentabilidad departamentos',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Rentabilidad departamentos', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
    {
      path: '/produccion/dashboard-ceo',
      name: 'produccion_dashboard_ceo',
      component: () => import('@/views/produccion/ProduccionItem.vue'),
      props: { title: 'Dashboard CEO' },
      meta: {
        pageTitle: 'Dashboard CEO',
        breadcrumb: [
          { text: 'Producción' },
          { text: 'Dashboard CEO', active: true },
        ],
        requiresAuth: true,
        requiredPermission: 'consultar_produccion',
      },
    },
   
   


    {
      path: '/',
      name: 'home',
      component: () => import('../views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
        requiresAuth: true,
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },
    
   
    // {
    //   path: '/signos_vitales/:token',
    //   name: 'signos_vitales',
    //   component: () => import('../views/signosVitales/CrearSignosVitales.vue'),
    //   meta: {
    //     pageTitle: 'Citas',
    //     breadcrumb: [
    //       {
    //         text: 'Citas',
    //         to: '/consultar_citas'
    //       },
    //       {
    //         text: 'Signos Vitales',
    //         active: true,
    //       },
    //     ],
    //     requiresAuth: true,
    //     requiredPermission: 'citamedica_consultar_signosvital', // Permiso requerido agregado
    //     excel: false,
    //     pdf: false,
    //   },
    // },
   
    
    {
      path: '/consultar_auxiliar',
      name: 'consultar_auxiliar',
      component: () => import('@/views/administracion/pages/auxiliares/ConsultarAuxiliar.vue'),
      meta: {
        pageTitle: 'Cartera Auxiliares',
        breadcrumb: [
          
          {
            text: 'Auxiliares Médicos',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'adm_consultar_auxiliar', // Permiso requerido
        accion1: { url: '/crear_auxiliar' }
      },
    },

    {
      path: '/crear_auxiliar',
      name: 'crear_auxiliar',
      component: () => import('../views/administracion/pages/auxiliares/CrearAuxiliar.vue'),
      pageTitle: 'Auxiliar Medico',
      meta: {
        pageTitle: 'Auxiliar Medico',
        breadcrumb: [
          {
            text: 'Consultar Auxiliar',
            to: '/consultar_auxiliar' // <-- Add this line
          },
          {
            text: 'Crear Auxiliar Medico',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'crear_auxiliar', // Permiso requerido hasta aqui llegue
      },
    },

    {
      path: '/editar_auxiliar/:token',
      name: 'editar_auxiliar',
      component: () => import('@/views/administracion/pages/auxiliares/EditarAuxiliar.vue'),
      meta: {
        pageTitle: 'Editar Auxiliar',
        breadcrumb: [
          {
            text: 'Consultar Auxiliar',
            to: '/consultar_auxiliar',
          },
          {
            text: 'Editar Auxiliar',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'editar_auxiliar', // Permiso requerido
      },
    },
    

    {
      path: '/editar_cita/:token',
      name: 'editar_cita',
      component: () => import('@/views/citas/pages/CrearCita.vue'),
      
      meta: {
        pageTitle: 'Editar Cita',
        breadcrumb: [
          {
            text: 'Citas',
            to: '/consultar_citas' // <-- Add this line
          },
          {
            text: 'Editar cita',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'citamedica_editar_cita',
        excel: false,
        pdf: false,
      },
    },
    
    {
      path: '/crear_atencion_medica/:id',
      name: 'crear_atencion_medica',
      // component: () => import('../views/atencionmedica/Crearcitamedica.vue'),
      component: () => import('../views/atencionCita/pages/CrearAtencion.vue'),
      meta: {
        pageTitle: 'Creacion atención medica',
        breadcrumb: [
          {
            text: 'Citas',
            to: '/consultar_citas' // <-- Add this line
          },
          {
            text: 'Atencion Médica',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'atencionmedica_crear_atencion',
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/editar_atencion_medica/:token',
      name: 'editar_atencion_medica',
      component: () => import('../views/atencionCita/pages/EditarAtencion.vue'),
      meta: {
        pageTitle: 'Creacion atención medica',
        breadcrumb: [
          {
            text: 'Citas',
            to: '/consultar_citas' // <-- Add this line
          },
          {
            text: 'Editar Atencion Médica',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'atencionmedica_crear_atencion',
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/cartera_atencion_medica/',
      name: 'cartera_atencion_medica',
      component: () => import('../views/atencionMedica/pages/CarteraAtencionMedica.vue'),
      meta: {
        pageTitle: 'Cartera Atencion Medica',
        breadcrumb: [
          {
            text: 'Cartera Atencion Medica',
            to: '/cartera_atencion_medica' 
          },
        ],
        requiresAuth: true,
        requiredPermission: 'rep_archivo_plano',
      },
    },
    {
      path: '/archivo_plano/',
      name: 'archivo_plano',
      component: () => import('../views/reporte/pages/ArchivoPlano.vue'),
      meta: {
        pageTitle: 'Archivo Plano',
        breadcrumb: [
          {
            text: 'Generacion Archivo Plano',
            to: '/archivo_plano' 
          },
        
        ],
        requiresAuth: true,
        requiredPermission: 'rep_archivo_plano',
        
        excel: false,
        pdf: false,
      },
    },
    

    {
      path: '/archivo_pdf/',
      name: 'archivo_pdf',
      component: () => import('../views/reporte/pages/ArchivoPdf.vue'),
      meta: {
        pageTitle: 'Archivo Pdf',
        breadcrumb: [
          {
            text: 'Generacion de Archivo PDF',
            to: '/archivo_pdf' 
          },
        
        ],
        requiresAuth: true,
        requiredPermission: 'rep_archivo_plano',
        
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/crear_cita',
      name: 'crear_cita',
      component: () => import('../views/citas/pages/CrearCita.vue'),
  
      meta: {
        pageTitle: 'Archivos',
        breadcrumb: [
          {
            text: 'Citas',
            to: '/consultar_citas' // <-- Add this line
          },
          {
            text: 'Crear cita',
            active: true,
          },
        ],
        requiresAuth: true,
        requiredPermission: 'citamedica_crear_cita',
        // accion1: { url: '/rol/new/' },
        excel: false,
        pdf: false,
      },
    },
    {
      path: '/codigo_qr/:token',
      name: 'codigo_qr',
      component: () => import('../views/citas/Codigoqr.vue'),
  
      meta: {
        pageTitle: 'Codigo QR Atención Médica',
        // breadcrumb: [
        //   {
        //     text: 'Citas',
        //     to: '/consultar_citas' // <-- Add this line
        //   },
        //   {
        //     text: 'Crear cita',
        //     active: true,
        //   },
        // ],
        requiresAuth: true,
        requiredPermission: 'citamedica_codigoqr',
        // accion1: { url: '/rol/new/' },
       
      },
    },
    {
      path: '/codigo_qrcita/:token',
      name: 'codigo_qrcita',
      component: () => import('../views/citas/Codigoqrencuestacita.vue'),
  
      meta: {
        pageTitle: 'Codigo QR Cita',
        // breadcrumb: [
        //   {
        //     text: 'Citas',
        //     to: '/consultar_citas' // <-- Add this line
        //   },
        //   {
        //     text: 'Crear cita',
        //     active: true,
        //   },
        // ],
        requiresAuth: true,
        requiredPermission: 'citamedica_codigoqr',
        // accion1: { url: '/rol/new/' },
       
      },
    },
    {
      path: '/calificacion_atencionmedica/:token',
      name: 'calificacion_atencionmedica',
      component: () => import('../views/citas/Formularioqr.vue'),
  
      meta: {
        pageTitle: 'Calificación',
        // breadcrumb: [
        //   {
        //     text: 'Citas',
        //     to: '/consultar_citas' // <-- Add this line
        //   },
        //   {
        //     text: 'Crear cita',
        //     active: true,
        //   },
        // ],
        requiresAuth: false,
        // accion1: { url: '/rol/new/' },
       
      },
    },
    {
      path: '/calificacion_cita/:token',
      name: 'calificacion_cita',
      component: () => import('../views/citas/Formularioqrcita.vue'),
  
      meta: {
        pageTitle: 'Calificación Cita',
        // breadcrumb: [
        //   {
        //     text: 'Citas',
        //     to: '/consultar_citas' // <-- Add this line
        //   },
        //   {
        //     text: 'Crear cita',
        //     active: true,
        //   },
        // ],
        requiresAuth: false,
        // accion1: { url: '/rol/new/' },
       
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('../views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/not-permitted',
      name: 'not-permitted',
      component: () => import('@/views/error/NotPermitted.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
